const SaveButton = ({
    buttonName = "Save",
    extraClassName = "",
    loading = false,
    disabled = false,
}) => {
    return (
        <div className='text-right'>
            <button type='submit' className={`add-button ${extraClassName}`}
                disabled={loading || disabled}
            >
                <span className="save-button-content">
                    {loading ? 'Saving...' : buttonName}
                </span>
            </button>
        </div>
    );
};

export default SaveButton;
